import { registerSW } from 'virtual:pwa-register';

/**
 * De service worker precachet de app-shell. `autoUpdate` betekent dat een nieuwe
 * versie meteen wordt geïnstalleerd en de pagina overneemt.
 *
 * Zonder `onNeedReload` herlaadt `vite-plugin-pwa` de pagina op dat moment zelf -
 * ook midden in een opname, en ook als een ander tabblad de nieuwe versie ophaalde.
 * Een half getypte bevindingtekst of een tik die nog onderweg was, is dan weg, en de
 * opname begint weer bij het eerste onderdeel. Daarom herlaadt de app nooit zelf:
 * `UpdateNotice` laat de gebruiker vernieuwen wanneer het uitkomt.
 */
export function startServiceWorker(register: typeof registerSW = registerSW): void {
    register({ immediate: true, onNeedReload: () => {} });
}
